import { render, staticRenderFns } from "./IdentityDocumentUpload.vue?vue&type=template&id=7ef397b8&"
import script from "./IdentityDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./IdentityDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports